var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ChipContainer, Message, CustomIcon } from './mixins';
import { IconColorHook } from './utils';
export const Chip = (_a) => {
    var { iconName, text, chipOptions = { size: 'medium', variant: 'darken', skin: 'outline', color: 'extra' } } = _a, rest = __rest(_a, ["iconName", "text", "chipOptions"]);
    const { size = 'medium', variant = 'darken', skin = 'outline', color = 'extra' } = chipOptions;
    return (React.createElement(ChipContainer, Object.assign({ size: size, variant: variant, skin: skin, color: color }, rest),
        iconName && (React.createElement(CustomIcon, { name: iconName, size: "16", color: variant === 'darken' && skin === 'fill' ? '#FFFF' : IconColorHook({ variant, color, skin }) })),
        React.createElement(Message, { size: size, variant: variant, skin: skin, color: color }, text)));
};
